import { Navigate } from "react-router-dom";

// Dashboard

import Dashboard from "../pages/Dashboard";


import TransactionList from "../pages/TransactionList";

import SalesReport from "../pages/Report/SalesReport/index";

import Login from "../pages/Authentication/Login";
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import UserProfile from "../pages/Profile";
import UpdatePassword from "../pages/Authentication/UpdatePassword";
import AlertDetails from "../pages/Alert/AlertDetails";
import AlertList from "../pages/Alert/AlertList";
import AddRule from "../pages/Rule/RuleAdd";
import RuleList from "../pages/Rule/RuleList";
import ScenarioList from "../pages/Scenario/ScenarioList";
import ScenarioDetails from "../pages/Scenario/ScenarioDetails";
import RuleDetails from "../pages/Rule/RuleDetails";
import StoreList from "../pages/Stores/StoreList";
import UserList from "../pages/Users/UserList";
import StoreDetails from "../pages/Stores/StoreDetails";
import StoreGroupList from "../pages/StoreGroups/StoreGroupList";
import Settings from "../pages/Settings";
import ActivityLogs from "../pages/ActivityLogs";
import AlertReport from "../pages/Report/AlertReport";


interface RouteObject {
  path: string;
  component: any;
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [

  { path: "/index", component: <Dashboard /> },
  { path: "/dashboard", component: <Dashboard /> },

  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  { path: "*", component: <Navigate to="/dashboard" /> },

  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  { path: "*", component: <Navigate to="/dashboard" /> },

  { path: "/alerts", component: <AlertList /> },
  { path: "/alert/:id", component: <AlertDetails /> },


  { path: "/scenarios", component: <ScenarioList /> },
  { path: "/scenario/:id", component: <ScenarioDetails /> },


  { path: "/rule-add", component: <AddRule /> },
  { path: "/rule/:id", component: <RuleDetails /> },
  { path: "/rules", component: <RuleList /> },

  { path: "/transactions", component: <TransactionList /> },

  { path: "/stores", component: <StoreList/>},
  { path: "/store-groups", component: <StoreGroupList/>},
  { path: "/users", component: <UserList/>},
  { path: "/store/:id", component: <StoreDetails /> },


  { path: "/sale-report", component: <SalesReport /> },
  { path: "/alert-reports", component: <AlertReport /> },

  { path: "/user-profile", component: <UserProfile/>},
  { path: "/settings", component: <Settings/>},

  { path: "/activity-logs", component: <ActivityLogs />},

];

const publicRoutes: Array<RouteObject> = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/update-password", component: <UpdatePassword /> },

];

export { authProtectedRoutes, publicRoutes}